<form [formGroup]="formulario">
  <div>
    <div fxLayout="row">
      <div fxFlex fxLayoutAlign="center center">
        <h3 class="ps-title-large ps-confirm-element-delete-title">
          Você tem certeza?
        </h3>
      </div>
    </div>
    <div class="ps-confirm-element-delete-desc-content" fxLayout="row">
      <div fxFlex fxLayoutAlign="center center">
        <p class="ps-description-14">
          Esta ação <strong>não pode</strong> ser desfeita. Isso excluirá
          permanentemente o
          <strong class="ps-dialog-element-name">{{
            dataComponent.data.element.name
          }}</strong>
          e removerá todas as associações dele.
        </p>
      </div>
    </div>
    <div class="ps-confirm-element-delete-opts-content" fxLayout="column">
      <p class="ps-description-14">
        Digite
        <strong class="ps-dialog-element-name">{{
          dataComponent.data.element.name
        }}</strong>
        para confirmar.
      </p>
      <div fxFlex>
        <mat-form-field
          class="ps-dialog-form-field"
          [formGroup]="formulario"
          appearance="fill"
          fxFlex>
          <!-- <mat-label>Nome</mat-label> -->
          <input type="text" matInput formControlName="element_name" />
        </mat-form-field>
      </div>
    </div>
    <mat-dialog-actions class="ps-dialog-container-actions">
      <div fxLayout="row" fxFill style="margin-top: 2px">
        <div
          fxFlex
          fxLayoutAlign="end center"
          class="ps-dialog-content-actions">
          <button
              mat-raised-button
            (click)="dataComponent.data.confirmed = formulario.valid"
            [disabled]="!formulario.valid"
            class="ps-dialog-delete-button mat-raised-button"
            color="primary"
            [mat-dialog-close]="true">
            {{ dataComponent.data.titleButton }}
          </button>
        </div>
      </div>
    </mat-dialog-actions>
  </div>
</form>
